module.exports = __webpack_public_path__ + "img/pic3.123e3e47.png";